import { render, staticRenderFns } from "./sbwCfg.vue?vue&type=template&id=79729da2&scoped=true"
import script from "./sbwCfg.vue?vue&type=script&lang=js"
export * from "./sbwCfg.vue?vue&type=script&lang=js"
import style0 from "./sbwCfg.vue?vue&type=style&index=0&id=79729da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79729da2",
  null
  
)

export default component.exports